<template>
  <div id="app">
    <div id="nav" v-if="showNav">
      <div class="nav-links col-sm-6 col-xs-12">
        <router-link to="/about"><h4>about</h4></router-link>
        <router-link to="/#work" @click.native="scrollFix('#work')"><h4>work</h4></router-link>
        <router-link to="/sayhello"><h4>say hello</h4></router-link>
      </div>
    </div>
    <router-view/>
    <div class="footer">
      <p>&copy; {{currentYear}} <a href="mailto:enorrback1@gmail.com">Einar Norrback</a></p>
    </div> 
  </div>
</template>

<script>

export default {
  name: "App",
  computed: {
    showNav: function () {
      // return this.$route.path != "/admin" && this.$route.path != "/login"
      return false
    },
    currentYear: function () {
      return new Date().getFullYear()
    }
  },
  created: function () {
    const root = document.documentElement;
    root.style.setProperty('--body-bg', '#ffffff;');   
    root.style.setProperty('--text-primary', '#343434');
  },
  mounted: function () {
    // From testing, without a brief timeout, it won't work.
    setTimeout(() => this.scrollFix(this.$route.hash), 1);    
  },
  methods: {
  scrollFix: function(hashbang)
  {
    location.hash = hashbang;
  }
}
} 
</script>

<style lang="less">
.img-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #68c29a;
  color: #FFF;
  font-size: smaller;
  border-radius: 2px;
}
:root {
  --text-primary: #343434;
  --text-secondary: #343434;
  --bg-primary: #ffffff;
  --bg-secondary: #343434;
  --accent: #68c29a;
  --body-bg: #ffffff;
  --text-on-primary-bg: #343434;
}
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: var(--body-bg);
  color: var(--text-primary);
} 
.footer {
  margin-top: 100px;
  margin-bottom: 50px;
}
a {
  color: var(--accent);
}
a:hover {
  color: lighten(#68c29a, 15%);
}

@font-face {
    font-family: 'GilroyExtraBold';
    src: local('Gilroy ExtraBold'), local('Gilroy-ExtraBold'),
        url('~@/assets/fonts/Gilroy-ExtraBold.woff2') format('woff2'),
        url('~@/assets/fonts/Gilroy-ExtraBold.woff') format('woff');
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: 'GilroyLight';
    src: local('Gilroy Light'), local('Gilroy-Light'),
        url('~@/assets/fonts/Gilroy-Light.woff2') format('woff2'),
        url('~@/assets/fonts/Gilroy-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

#app {
  a, a:hover, a:focus, a:visited, a:active {
    text-decoration: none; 
  }
  .container {
    padding: 0 20px 0 20px;
  }
  .footer {
    font-size: smaller; 
    text-align: center;
    a {
      font-weight: 800;
    }
  }
  text-align: center;
  font-family: 'GilroyLight';
  h1, h2, h3, h4 {
    color: var(--text-primary);
    font-family: 'GilroyExtraBold';
    text-transform: uppercase;
  }
}

#nav {
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  z-index: 2;
  background-color: var(--bg-primary);
  position: fixed;
  top: 0;
  width: 100%;
  .nav-links {
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-content: center;    
  }
  h4 {
    display: inline-block;
    font-family: 'GilroyLight';
    text-transform: uppercase;    
  }
  a {
    text-decoration: none;
    color: var(--text-primary);
    // active page
    &.router-link-exact-active {
      color: lighten(#e91e63, 10%);
    }
  }
  a:hover {
    transition: all .2s ease-out;
    color: #e91e63;
  }
}
// FORM STUFF
.form-title {
    margin-top: 80px;
    color: white;
}
form {
    line-height: 1.875;
    padding: 20px 20px 0px 20px;
    background-color: white;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);    
}
input { border-style: none; background: transparent; outline: none; }
button { padding: 0; background: none; border: none; outline: none; }

/* Material Design Form Inputs */
.form__wrapper {
  overflow: hidden;
  position: relative;
  z-index: 1;
  display: inline-block;
  margin-bottom: 1.6rem;
  width: 100%;
  vertical-align: top;
}

.form__wrapper--submit {
  padding: 1.6rem 0;
}

.form__input {
  display: block;
  position: relative;
  margin-top: 1em;
  padding: 1.4em 0 0.5em;
  width: 100%;
  box-sizing: border-box;
  color: #444;
  font-size: 1.2rem;
  outline: 0;
  border: none;
  border-bottom: solid 1px #ddd;
  -webkit-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -moz-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -o-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 96%, #e91e63 4%);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, #e91e63 4%);
  background-position: -400px 0;
  background-size: 400px 100%;
  background-repeat: no-repeat;
  /**
   * Remove default box-shadow for required pseudo classes 
   */
  /**
   *  When input contain a class of .error 
   */
}
.form__input:required {
  box-shadow: none;
}
.form__input.error {
  -webkit-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -moz-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -o-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 96%, #f44336 4%);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 96%, #f44336 4%);
  background-position: 0 0;
  background-size: 400px 100%;
  background-repeat: no-repeat;
}
.form__input:focus {
  background-position: 0 0;
  color: #444;
  -webkit-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -moz-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -o-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

/* Form Label */
.form__label {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: calc(100% - 1em);
  text-align: left;
  pointer-events: none;
  color: #999;
}

/* Form Label Content */
.form__label-content {
  position: absolute;
  -webkit-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -moz-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  -o-transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
  transition: all 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

/**
 * 1. When input is focused move the label to top
 * 2. when the input field has a value move the label to top
 */
.form__input:focus ~ .form__label .form__label-content,
.form--filled .form__label-content {
  font-size: 1.2rem;
  -webkit-transform: translate3d(0, -65%, 0);
  -moz-transform: translate3d(0, -65%, 0);
  transform: translate3d(0, -65%, 0);
}

/* Basic Buttons */
.btn {
  display: inline-block;
  padding: 0.6em 1.5em;
  border-radius: 2px;
  background-color: #e91e63;
  color: #fff;
  border: 0;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 400;
  font-size: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24), 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
}
.btn:focus, .btn:hover {
  background-color: lighten(#e91e63, 15%);
}
.btn.btn-block {
  width: 100%;
  display: block;
}
.btn-outline {
  background-color: transparent;
  color: var(--accent);
  border: 2px solid var(--accent);
  border-radius: 4px;
  box-shadow: none;
}
.btn-outline:hover {
  color: #ffffff;
}
button:disabled {
  cursor: not-allowed;
  box-shadow: none;
  background-color: #E0E0E0;
  color: #343434;
}
button:disabled:hover {
  background-color: #E0E0E0;
  color: #343434;
}
.form__wrapper-textarea {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;  
  .form__input-textarea {
    resize: vertical;
    font-family: inherit;
    width: 100%;
    border: 0;
    border-bottom: 1px solid #d2d2d2;
    outline: 0;
    color: #444;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
  }
  .form__input-textarea::placeholder {
    color: transparent;
  }

  .form__input-textarea:placeholder-shown ~ .form__label-textarea {
    cursor: text;
    top: 20px;
  }

  label,
  .form__input-textarea:focus ~ .form__label-textarea {
    position: absolute;
    top: -10px;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #999;
  }

  .form__input-textarea:focus {
    padding-bottom: 6px;
    border-bottom: 2px solid var(--accent);
  }
}
img.lazy, .lazy-card {
-webkit-filter: blur(2px); -moz-filter: blur(2px);
-o-filter: blur(2px); -ms-filter: blur(2px); 
filter: blur(2px);  
filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='0.2');
-webkit-transition: 0.25s -webkit-filter linear;
-o-transition: 0.25s -o-filter linear;
transition: 0.25s linear;
}
.text-danger {
  color: #e53935;
}
</style>
